const alertDialog = {
    successTitle: 'Success',
    successText: 'The operation was completed successfully.',
    failTitle: 'Fail',
    failText: 'Something went wrong while performing the operation.',
    ok: 'Ok',
};
const statuses = {
    available: 'Available',
    onModeration: 'On moderation',
    declined: 'Declined',
    soldOut: 'Sold out',
    unpublished: 'Unpublished',
    distress: 'Distress',
};
const floorsList = {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    null: '',
};
const paymentMethods = {
    bank_check: 'Bank check',
    credit_debit_card: 'Debit/credit card',
    cash: 'Cash',
    bank_transfer: 'Bank transfer',
    crypto: 'Crypto',
};
const heightsList = {
    Simplex: 'Simplex',
    Duplex: 'Duplex',
    Triplex: 'Triplex',
    Quadruplex: 'Quadruplex',
    'Five Floors': 'Five Floors',
    'Six Floors': 'Six Floors',
    Loft: 'Loft',
    simplex: 'Simplex',
    duplex: 'Duplex',
    triplex: 'Triplex',
    quadruplex: 'Quadruplex',
    'five floors': 'Five Floors',
    'six floors': 'Six Floors',
    loft: 'Loft',
};
const units = {
    units_one: '{{count}} unit',
    units_two: '{{count}} units',
    units_few: '{{count}} units',
    units_many: '{{count}} units',
    units_other: '{{count}} units',
};
const projects = {
    projects_one: '{{count}} project',
    projects_two: '{{count}} projects',
    projects_few: '{{count}} projects',
    projects_many: '{{count}} projects',
    projects_other: '{{count}} projects',
};
const roles = {
    broker: 'User',
    head_of_sales_department: 'Administrator',
    admin: 'Supreme administrator',
};
const passwordRecoveryModal = {
    header: 'Password recovery',
    body: 'Enter your email address and we will send you a link to reset your password.',
    forgotSubmited: 'We have sent you a letter, follow the link provided in it to create a new password.',
    continue: 'Continue',
    ok: 'Ok',
};
const changePasswordModal = {
    title: 'Change password',
    body: 'Create a new password. It must be at least 8 characters long and include at least one uppercase and lowercase letter, number, and symbol.',
    uppercaseAndLowercaseLetterTitle: 'The password must contain at least one lowercase and one uppercase letter.',
    oneDigitTitle: 'The password must contain at least one digit.',
    specialSymbolTitle: 'The password must contain at least one special character.',
    minimumLengthTitle: 'The password length must be at least 8 characters.',
    oldPassword: {
        title: 'Current password',
        placeholder: 'Enter current password',
    },
    newPassword: {
        title: 'New password',
        placeholder: 'Enter new password',
    },
    newPasswordConfirm: {
        title: 'Confirm password',
        placeholder: 'Confirm new password',
    },
    forgotButton: 'I forgot my password',
    passwordSubmited: {
        header: 'You now have a new password!',
        body: 'The new password has been successfully created and you can now use it to log into Geniemap.',
    },
    continue: 'Continue',
    ok: 'Ok',
};
const editImage = {
    title: 'Edit image',
    reset: 'Reset',
    apply: 'Apply',
};
const profileForm = {
    generalSubheader: 'General info',
    name: 'Firstname Lastname',
    emailTooltip: 'If you want to update the email, please ask your administrator.',
    phone: 'Phone number',
    socialSubheader: 'Social networks',
    socialNetworksTooltip: 'Optional fields. They will appear as additional contacts in your catalog.',
};
const catalogSettingsModal = {
    title: 'Personalise catalog',
    titleMobile: 'Set up catalog',
    tab1: 'General',
    tab2: 'Additional slides',
    themeColor: 'Theme color',
    language: 'Language',
    measures: 'Measures',
    currency: 'Currency',
    additionalCurrency: 'Additional currency',
    additionalCurrencyHint: 'Displays prices in \ntwo different currencies.',
    noAdditionalCurrency: 'No additional currency',
    socialNetworks: 'Display my social networks',
    unitsWithLayouts: 'Units with layouts',
    hideUnitsNumbers: 'Hide units numbers',
    fullUnitsList: 'Full units list',
    areaSlide: 'Project location',
    hideDeveloper: 'Hide developer',
    hideDeveloperHint: 'Removes the developer’s name from the project title and description.',
    developerSlide: 'Developer description',
    customSlide: 'Custom slide',
    customSlideTitle: 'Slide title',
    customSlideText: 'Text on the slide',
    customSlideHint: 'Displays at the end of the catalog. \nYou can add image and text to the slide.',
    requiredField: 'Required field',
    reset: 'Reset to default',
    resetMobile: 'Reset',
    save: 'Save',
    selectImage: 'Select image',
};
const filters = {
    title: 'Filters',
    clear: 'Clear',
    reset: 'Reset',
    tabs: {
        location: {
            title: 'Location',
            search: 'Search for location',
            region: {
                AE: 'Emirate',
                default: 'Region',
            },
            regionNoData: {
                AE: 'No emirates match your search',
                default: 'No regions match your search',
            },
            districts: 'District',
            districtsNoData: 'No districts in selected emirates',
            districtsRegionsNoData: 'No districts in selected regions',
        },
        company: {
            title: 'Company',
            search: 'Search for company',
            noResultsFound: 'No result found',
            tryDifferentSearchOptions: 'Try using different search options',
            addToFavoriteError: 'Error adding to favorites',
            favourites: 'Favourite companies',
            tabs: {
                all: 'All',
                developers: 'Developers',
                agencies: 'Agencies',
            },
        },
        moreFilters: {
            title: 'Main filters',
            statisticsTitle: 'More filters',
            showMe: {
                title: 'Additional filters',
                favourites: 'Favourites',
                preLaunch: 'Pre-launch',
                soldOut: 'Sold out',
                myAgencyUnits: 'My agency units',
                developerStock: 'Developer stock',
                resale: 'Resale',
                distress: 'Distress',
            },
            availability: {
                title: 'Project Status',
            },
            handover: {
                title: 'Completion status',
                from: 'Completion from',
                to: 'Completion to',
                offPlan: 'Off plan',
                ready: 'Ready',
                year: 'Year',
                quarter: 'Quarter',
                unselected: 'Not selected',
                preset_one: '<{{count}} year',
                preset_two: '<{{count}} years',
                preset_few: '<{{count}} years',
                preset_many: '<{{count}} years',
                preset_other: '<{{count}} years',
            },
            price: {
                title: 'Price',
                from: 'From',
                to: 'To',
            },
            pricePerSquare: {
                title: 'Price per {{squareMeasurement}}',
                from: 'From',
                to: 'To',
            },
            size: {
                title: 'Size',
                from: 'From',
                to: 'To',
            },
            height: {
                title: 'Unit height',
            },
            ownershipType: {
                title: 'Type of ownership',
                allTypes: 'All types',
                leasehold: 'Leasehold',
                freehold: 'Freehold',
            },
            layout: {
                title: 'Layout',
            },
            unitType: {
                title: 'Unit type',
            },
            furnishing: {
                title: 'Furnishing',
            },
            unitFeatures: {
                title: 'Unit features',
            },
            serviceCharge: {
                title: {
                    TH: 'Sinking fund/Maintance fee',
                    default: 'Service charge',
                },
                from: 'From',
                to: 'To',
            },
            paymentPlans: {
                title: 'Payment plans',
                subtitle: 'Down payment',
                secondSubtitle: 'Down payment in {{currency}}',
                from: 'From',
                to: 'To',
                postHandover: 'Post handover',
            },
            forAdmins: {
                title: 'For admins',
                allUnits: 'All units',
                unitsWithLayouts: 'Units with layouts only',
                unitsWithoutLayouts: 'Units without layouts only',
            },
            hints: {
                favorite: 'Projects you’ve added to favourites',
                ourUnits: 'Resale units listed by your company',
                serviceCharge: 'Annual service charge',
                postHandover: 'Includes payments after handover.',
            },
        },
    },
};
const measures = {
    language: 'Language',
    russianLanguage: 'Russian',
    englishLanguage: 'English',
    arabicLanguage: 'Arabic',
    currency: 'Currency',
    measures: 'Measures',
};
const countries = {
    modalTitle: 'Countries',
    planTitle: '{{available}}/{{total}} countries',
    planSubtitle: 'Available in your plan.',
    planHint: 'Ask your manager for more access.',
    subtitles: {
        projects1000: '1000+ projects',
        projects500: '500+ projects',
        projectsCount: '{{count}}+ projects',
        noProjectsYet: 'No projects yet',
        readyToConnect: 'Ready to connect',
        comingSoon: 'Coming soon',
    },
    footer: 'Discover diverse real estate options worldwide →',
    changeCountryError: {
        title: 'Could not switch country',
        description: 'Please try again later',
    },
};
const login = {
    welcome: 'Welcome 👋',
    description: 'Start tracking the best properties in the UAE',
    email: 'Email',
    password: 'Password',
    login: 'Login',
    forgotPassword: 'Forgot password?',
    registrationRequest: 'Registration request',
    passwordRecovery: {
        header: 'Password recovery',
        body: 'Enter your email address and we will send you a link to reset your password.',
        forgotSubmited: 'We have sent you a letter, follow the link provided in it to create a new password.',
    },
    continue: 'Continue',
    ok: 'Ok',
};
const autocomplete = {
    searchPlaceholder: 'Search',
    noMatch: 'No match',
};
const noSelected = 'No selected';
export { alertDialog, statuses, floorsList, paymentMethods, heightsList, units, projects, roles, passwordRecoveryModal, changePasswordModal, editImage, profileForm, catalogSettingsModal, filters, measures, countries, login, autocomplete, noSelected, };
